import { motion } from "framer-motion";

export default function PageHero({ kicker, title, subtitle, image, testid }) {
  return (
    <section className="relative pt-40 pb-24 sm:pt-48 sm:pb-32 overflow-hidden" data-testid={testid}>
      <div className="absolute inset-0">
        <img src={image} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-plum-dark/78" />
        <div className="absolute inset-0 bg-gradient-to-t from-cream via-transparent to-transparent" />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.span initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
          className="text-gold-light text-sm tracking-[0.24em] uppercase font-semibold">{kicker}</motion.span>
        <motion.h1 initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.1 }}
          className="font-heading text-cream text-4xl sm:text-5xl lg:text-6xl font-semibold mt-4 max-w-3xl leading-[1.02] text-balance">{title}</motion.h1>
        {subtitle && (
          <motion.p initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.2 }}
            className="text-cream/85 text-lg mt-6 max-w-2xl leading-relaxed">{subtitle}</motion.p>
        )}
      </div>
    </section>
  );
}
